import { render, staticRenderFns } from "./CustomerEditTabSocial.vue?vue&type=template&id=4ef5ed02&"
import script from "./CustomerEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./CustomerEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports